"use strict";

var _interopRequireDefault = require("D:/www/ssz_gold_backend/multi_merchant_web/gold_admin/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _recommend = require("@/api/recommend");

var _add = _interopRequireDefault(require("./add"));

var _customPage = _interopRequireDefault(require("@/components/customPage"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    addDialog: _add.default,
    customPage: _customPage.default
  },
  data: function data() {
    return {
      tableData: [],
      total: 0,
      editId: null
    };
  },
  methods: {
    // 弹出添加弹窗
    openAdd: function openAdd(id) {
      this.editId = id ? id : null;
      this.$refs.addDialog.dialogVisible = true;
    },
    // 更改状态
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      (0, _recommend.addOrEditH5BannerSet)({
        id: id,
        status: status == 1 ? 0 : 1
      }).then(function (res) {
        _this.getList();
      });
    },
    // 更改顺序
    changeSort: function changeSort(id, val) {
      var _this2 = this;

      (0, _recommend.addOrEditH5BannerSet)({
        id: id,
        banner_sort: val
      }).then(function (res) {
        _this2.getList();
      });
    },
    // 删除
    removeItem: function removeItem(id) {
      var _this3 = this;

      this.$confirm('您确定要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _recommend.delH5BannerSet)(id).then(function (res) {
          _this3.getList();
        });
      }).catch(function () {});
    },
    getList: function getList() {
      var _this4 = this;

      var _this$$refs$customPag = this.$refs.customPage,
          page = _this$$refs$customPag.page,
          pageSize = _this$$refs$customPag.pageSize;
      (0, _recommend.h5BannerSetList)({
        page: page,
        pageSize: pageSize
      }).then(function (res) {
        _this4.tableData = res.data;
        _this4.total = res.total;
      });
    }
  },
  mounted: function mounted() {
    this.getList();
  }
};
exports.default = _default;